/*
  Restyle PDP PhotoSwipe (media zoom) arrow controls to use custom-pill-icon-button
  chrome and brand chevron icons. Zoom/close keep theme defaults.
*/
(function () {
  var LIGHTBOX_SELECTOR = '.pswp.pswp--product-lightbox';
  var BUTTON_SELECTOR = '.pswp__button--arrow--prev, .pswp__button--arrow--next';

  var ICON_PREV =
    '<span class="custom-icon custom-icon-chevron-left" aria-hidden="true">' +
    '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">' +
    '<path d="M29 2L11 20L29 38" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg></span>';

  var ICON_NEXT =
    '<span class="custom-icon custom-icon-chevron-right" aria-hidden="true">' +
    '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="25" viewBox="0 0 12 25" fill="none">' +
    '<path d="M1 0.5L11 12.5L1 24.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg></span>';

  var enhancedLightboxes = new WeakSet();

  function styleButton(button) {
    if (!(button instanceof Element) || button.dataset.customPillStyled === 'true') return;

    button.dataset.customPillStyled = 'true';
    button.classList.add('custom-pill-icon-button', 'hover-scale');

    if (button.classList.contains('pswp__button--arrow--prev')) {
      button.innerHTML = ICON_PREV;
    } else if (button.classList.contains('pswp__button--arrow--next')) {
      button.innerHTML = ICON_NEXT;
    }
  }

  function styleLightbox(root) {
    if (!(root instanceof Element)) return;
    root.querySelectorAll(BUTTON_SELECTOR).forEach(styleButton);
  }

  function watchLightbox(root) {
    if (!(root instanceof Element) || enhancedLightboxes.has(root)) return;
    enhancedLightboxes.add(root);
    styleLightbox(root);

    new MutationObserver(function () {
      styleLightbox(root);
    }).observe(root, { childList: true, subtree: true });
  }

  function scan() {
    document.querySelectorAll(LIGHTBOX_SELECTOR).forEach(watchLightbox);
  }

  if (document.body) {
    new MutationObserver(scan).observe(document.body, { childList: true });
  }

  scan();
})();
